module.exports = __webpack_public_path__ + "img/1_028.ab0d2303.jpg";